import { useEffect, useState } from 'react';
import { AccountInformation, Address } from '../../types/manageAccount.type';
import { AreaDetail, RaiseRequestServices } from '../../services/raiseRequest.services';

export default function useAddressDetails(
  userDetails: AccountInformation | null,
  setUserDetails: any,
  setEditing: any,
) {
  const [updatedDetails, setUpdatedDetails] = useState<Address | null>(null);
  const [newPincode, setNewPincode] = useState('');
  const [step, setStep] = useState(0);
  const [areas, setAreas] = useState<AreaDetail[]>([]);
  const [selectedAreaIndex, setSelectedAreaIndex] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<{ [key: string]: string }>({});

  const fetchAreas = async (pincode: string) => {
    try {
      const response = await RaiseRequestServices.getDetailsByPincode(pincode);
      setAreas(response);
    } catch (error) {
      console.log('Error fetching areas: ', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setUpdatedDetails(userDetails?.address_details[0] ?? null);
    setEditing(false);
    setStep(0);
    setError({});
  };

  const handlePincodeSubmit = async () => {
    setLoading(true);
    await fetchAreas(newPincode);
    setStep(1);
  };

  const isValid = () => {
    let _isValid = true;
    if (!updatedDetails) return false;

    if (!updatedDetails?.house_no) {
      setError((e) => ({ ...e, 'House No': 'This field is required' }));
      _isValid = false;
    }

    if (!updatedDetails?.line1 && !updatedDetails?.line2 && !updatedDetails?.line3) {
      setError((e) => ({ ...e, 'Address Line 1': 'This field is required' }));
      _isValid = false;
    }

    return _isValid;
  };

  const handleSaveClick = () => {
    if (!isValid()) return;
    setUserDetails({ ...userDetails, address_details: [updatedDetails] });
    setEditing(false);
    setStep(0);
  };

  const handleAreaSubmit = () => {
    if (selectedAreaIndex === null) return;

    const selectedArea = areas[selectedAreaIndex];
    setUpdatedDetails({
      ...updatedDetails,
      house_no: '',
      line1: '',
      line2: '',
      line3: '',
      street: selectedArea?.Area,
      city: selectedArea?.City,
      state: selectedArea?.State,
      zipcode: selectedArea?.PinCode,
    });
    setStep(2);
  };

  useEffect(() => {
    setUpdatedDetails(userDetails?.address_details[0] ?? null);
  }, [userDetails]);

  return {
    updatedDetails,
    setUpdatedDetails,
    newPincode,
    setNewPincode,
    step,
    setStep,
    areas,
    setAreas,
    selectedAreaIndex,
    setSelectedAreaIndex,
    loading,
    setLoading,
    handlePincodeSubmit,
    isValid,
    handleSaveClick,
    handleAreaSubmit,
    error,
    setError,
    handleCancel,
  };
}
